/*
 * "Weiterer Bedarf" is optional for BfS (EBS-38): the section may be submitted without
 * any selection, so it is always considered valid for progress / Next-button purposes.
 */
export const validateFurtherNeedSection = () => true;
